import React, { memo, useCallback } from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import { statusChipStyles } from './StatusFilterChip.styles';

const StatusFilterChip = ({ isActive, label, value, onSelect }) => {
  const onClick = useCallback(() => {
    onSelect(value);
  }, [value, onSelect]);

  return (
    <Box sx={statusChipStyles(isActive)} onClick={onClick}>
      {label}
    </Box>
  );
};

StatusFilterChip.propTypes = {
  isActive: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default memo(StatusFilterChip);
